import { FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import { FormattedMessage } from 'dibs-react-intl';
import BankAccountsIcon from 'dibs-icons/exports/legacy/BankAccount';
import { PaymentMethodSelectOption } from '../PaymentMethodSelectOption';
import { usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';
import { AchPaymentForm } from './AchPaymentForm';

export const AchPaymentMethod: FC = () => {
    const { selectedPaymentMethod, updateSelectedPaymentMethod, updateAchForm } =
        usePaymentMethodSelectContext();

    const isSelected =
        selectedPaymentMethod?.paymentMethodType === 'ACH' &&
        selectedPaymentMethod?.paymentProcessor === 'BRAINTREE' &&
        !selectedPaymentMethod?.paymentMethodToken;

    function handleSelect(): void {
        updateSelectedPaymentMethod({
            paymentMethodType: 'ACH',
            paymentProcessor: 'BRAINTREE',
        });
        updateAchForm({ isVerifying: false });
    }

    return (
        <PaymentMethodSelectOption
            isChecked={isSelected}
            onChange={handleSelect}
            dataTn="payment-method-ach-input"
            name="payment-method"
            value="ACH-BRAINTREE"
            icon={<BankAccountsIcon className={dibsCss.block} />}
            label={
                <div className={cn(dibsCss.flexGrow, dibsCss.sassyFontBodyMediumHeavy)}>
                    <FormattedMessage
                        id="dibs-payment.AchPaymentMethod.title"
                        defaultMessage="Bank Account"
                    />
                </div>
            }
            content={
                isSelected ? (
                    <div className={dibsCss.mtSmall}>
                        <AchPaymentForm />
                    </div>
                ) : null
            }
        />
    );
};
